import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import type { ChangeEvent } from 'react';

import { SearchFieldProps } from 'src/types/search';
import { StyledTextField } from './search-styles';


export const SearchField = ({
  placeholder = 'Search...',
  value,
  onChange,
  className,
}: SearchFieldProps): JSX.Element => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.value);
  };

  return (
    <StyledTextField
      variant="outlined"
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
